module.exports = __webpack_public_path__ + "assets/img/Best-Institutional-Forex-Broker-2020.6a65c32a.png";